export const SET_VERSION = (state, payload) => {
    state.version = payload;
}

export const SET_UPDATED_AT = (state, payload) => {
    state.updatedAt = payload;
}
